export enum DRC_METHOD {
  HEART_BEAT = 'heart_beat',
  DRONE_CONTROL = 'drone_control', // Flight control - virtual joystick
  DRONE_EMERGENCY_STOP = 'drone_emergency_stop', // Emergency stop
  OSD_INFO_PUSH = 'osd_info_push', // High-frequency OSD info push
  HSI_INFO_PUSH = 'hsi_info_push', // Obstacle avoidance info push
  DELAY_TIME_INFO_PUSH = 'delay_info_push', // Video transmission link delay info push
}

// Manual control
export interface DroneControlProtocol {
  x?: number; // Horizontal speed; positive = A command, negative = D command. Unit: m/s
  y?: number; // Forward/backward speed; positive = W command, negative = S command. Unit: m/s
  h?: number;// Vertical value; positive = ascend, negative = descend. Unit: m
  w?: number; // Heading angular velocity; positive = clockwise, negative = counterclockwise. Unit: degree/s (not implemented on web)
  seq?: number; // Counts from 0
}

// Low-latency OSD
export interface DRCOsdInfo {
  attitude_head: number;// Aircraft attitude heading angle. Unit: degree
  latitude: number;// Aircraft latitude/longitude
  longitude: number;
  altitude: number;
  speed_x: number;
  speed_y: number;
  speed_z: number;
  gimbal_pitch: number;// Gimbal pitch angle
  gimbal_roll: number;// Gimbal roll angle
  gimbal_yaw: number;// Gimbal yaw angle
}

// Situational awareness - HSI
export interface DRCHsiInfo {
  up_distance: number;// Obstacle distance above. Unit: mm
  down_distance: number;// Obstacle distance below. Unit: mm
  around_distances: number[]; // Horizontal observation points in [0,360): obstacle distance from aircraft in mm. 0 = straight ahead of the nose, clockwise (e.g. 90 = directly right of the aircraft)
  up_enable: boolean; // Upward obstacle avoidance switch state; true: enabled, false: disabled
  up_work: boolean; // Upward obstacle avoidance working state; true: working, false: abnormal or offline
  down_enable: boolean; // Downward obstacle avoidance switch state; true: enabled, false: disabled
  down_work: boolean; // Downward obstacle avoidance working state; true: working, false: abnormal or offline
  left_enable: boolean; // Left obstacle avoidance switch state; true: enabled, false: disabled
  left_work: boolean; // Left obstacle avoidance working state; true: working, false: abnormal or offline
  right_enable: boolean; // Right obstacle avoidance switch state; true: enabled, false: disabled
  right_work: boolean; // Right obstacle avoidance working state; true: working, false: abnormal or offline
  front_enable: boolean; // Forward obstacle avoidance switch state; true: enabled, false: disabled
  front_work: boolean; // Forward obstacle avoidance working state; true: working, false: abnormal or offline
  back_enable: boolean; // Backward obstacle avoidance switch state; true: enabled, false: disabled
  back_work: boolean; // Backward obstacle avoidance working state; true: working, false: abnormal or offline
  vertical_enable: boolean; // Combined vertical switch state; true (enabled) when both up and down switches are true, otherwise false (disabled)
  vertical_work: boolean; // Combined vertical working state; true (working) when both up and down are working, otherwise false (abnormal or offline)
  horizontal_enable: boolean; // Combined horizontal switch state; true (enabled) when front, back, left and right switches are all true, otherwise false (disabled)
  horizontal_work: boolean; // Combined horizontal working state; true (working) when front, back, left and right are all working, otherwise false (abnormal or offline)
}

export interface LiveViewDelayItem {
  video_id: string;
  liveview_delay_time: number;
}

// Link delay info
export interface DRCDelayTimeInfo {
  sdr_cmd_delay: number; // SDR link command delay. Unit: ms
  liveview_delay_list: LiveViewDelayItem[];
}

export interface DrcResponseInfo {
  result: number;
  output: {
    seq: number
  }
}
